import closest from 'dom-closest';

class SectionTracker {
    constructor(trackingJson, tokenHelpers) {
        this.trackingJson = trackingJson;
        this.setTrackingProps = tokenHelpers;
    }

    static track(trackObj) {
        delete trackObj.wire;
        if (
            typeof window !== 'undefined' &&
            typeof trackAsync !== 'undefined' &&
            typeof window.trackAsync === 'function'
        ) {
            window.trackAsync(trackObj);
        }
    }

    static trackPageView(trackObj) {
        if (typeof window.trackPageView === 'function') {
            window.trackPageView(trackObj);
        }
    }

    trackEventHandler(data, el) {
        const adobeObj = this.setTrackingProps(Object.assign({}, data.trackObj), el);
        if (adobeObj) {
            SectionTracker.track(adobeObj);
        }
    }

    /**
     *
     * @method init
     * @description Initializes tracking
     */
    init() {
        const app = this.trackingJson.app;
        const defaults = this.trackingJson.defaults;

        app.forEach((targetData) => {
            targetData.trackObj = Object.assign({}, targetData, defaults[targetData.wire.defaults]);
        });

        const trackEventHandler = this.trackEventHandler.bind(this);
        document.getElementById('scores-schedule-root').addEventListener('click', (event) => {
            app.forEach((targetData) => {
                // scope the node search to the given context.
                const closestTarget = closest(event.target, targetData.wire.selector);
                if (closestTarget) {
                    trackEventHandler(targetData, closestTarget);
                }
            });
        });
    }
}

export default SectionTracker;
